<a nz-popconfirm [nzPopconfirmTitle]="'Device.ConfirmScrap' | translate" [nzOkText]="'Common.Confirm' | translate"
    [nzCancelText]="'Common.Cancel' | translate" (nzOnConfirm)="confirm.emit()" nzPopconfirmPlacement="bottom">
    <button nzType="link" nz-button [nzTooltipTitle]="'Device.Scrap' | translate" nz-tooltip>
        <i nz-icon nzType="close-square" nzTheme="outline"></i>
    </button>
</a>